import React, { Component } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import $ from 'jquery';

import Navbar from './navbar';
import Footer from './footer';

import landigCTA from './../assets/images/placeholder/landigCTA.png';
import photoWoman from './../assets/images/placeholder/photo-woman.jpeg';
import { resetUser } from '../actions/user-api';
import { resetAuth } from '../actions/auth-api';

export const Landing = () => {
    const dispatch = useDispatch();
    const hideModal = () => {
        $('.modal').modal("hide");
    }

    window.location = "https://www.assistarobase.fr";
    return '';

    return (
        <div className="layout">
            <h1 className="sr-only visually-hidden">Assist@</h1>
            <Navbar />
            <main role="main" className="d-flex w-100 py-4 my-auto">
                <h1 className="sr-only visually-hidden">Assist@: Main</h1>
                <div className="container-fluid cover-container">
                    <div className="row align-items-center">
                        <div className="col-12 col-lg-5 text-center text-lg-left pt-5">
                            <h1 className="cover_h1 mt-n2 mb-sm mx-auto ml-lg-0">Accompagnement et aide à la gestion des formalités</h1>
                            <p className="cover_lead cover_lead-min mx-auto ml-lg-0 mb-6">Préparer vos démarches c'est faciliter demain</p>
                            <div className="cover_btns mx-auto ml-lg-0 mb-5 mb-lg-0 pt-gutter">
                                <Link to="/partner" className="btn btn-secondary mr-1 mr-lg-3">Accès partenaires</Link>
                                <Link to="/auth/signup/step1" className="btn btn-warning">Créer un compte</Link>
                            </div>
                        </div>
                        <div className="col-12 col-lg">
                            <img className="img-fluid mb-3 mb-lg-0" src={landigCTA} alt="Call to action" />
                        </div>
                    </div>
                </div>
            </main>
            <Footer />

            {/* <div className="modal fade px-0" id="commencerRegister" aria-labelledby="commencerRegisterLabel" aria-hidden="true">
                <div className="modal-dialog container-modal px-2">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="grid grid-md-2 grid-lg-copy gx-3 gx-lg-4">
                                <div className="block">
                                    <div className="img-placeholder img-copy rounded bg-light" style={{ backgroundImage: `url(${photoWoman})`, backgroundSize: 'Cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'left center' }} alt="placeholder" />
                                </div>
                                <div className="block d-flex flex-column justify-content-between">
                                    <h1 className="h1 text-primary font-weight-bolder ls-n1 lh-copy mb-0 mt-4 mt-lg-auto" id="commencerRegisterLabel">Bienvenue sur Assist@.</h1>
                                    <p className="h3 lh-base my-4">Je suis Aurélie, directrice générale de ce projet. <br />Je suis là pour vous aider tout au long du processus.</p>
                                    <p className="h5 lh-base">Si vous avez des questions, n'hésitez pas à nous contacter au 05.09.86.91.59</p>
                                    <div className="block mt-4 mt-lg-auto text-right">
                                        <Link to="/index" className="btn btn-light mr-1 mr-lg-3" data-dismiss="modal">Fermer</Link>
                                        <Link to="/auth/signup/step1" className="btn btn-info mr-1 mr-lg-3" onClick={() => {
                                            dispatch(resetAuth());
                                            dispatch(resetUser());
                                            if (localStorage.getItem("access_token") !== undefined) {
                                                localStorage.removeItem("access_token");
                                            }
                                            hideModal();
                                        }}>Commencer</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </div>
    )
}